import { apiFetch } from "./api";

/** Los dos apartados del documento que se arman eligiendo ítems. */
export type ApartadoDeCotizacion = "metodologia" | "documentacion";

/** Un ítem del catálogo con que se componen esos apartados. */
export interface CotizacionItem {
  id: number;
  /** Identidad estable; no se edita. Distingue variantes que dicen casi lo mismo. */
  codigo: string;
  apartado: ApartadoDeCotizacion;
  /** `null` en Documentación: sus ítems son líneas de una lista numerada. */
  rotulo: string | null;
  cuerpo: string;
  orden: number;
}

/** Un párrafo fijo del documento, editable desde el mantenedor. */
export interface CotizacionTexto {
  id: number;
  codigo: string;
  nombre: string;
  apartado: string;
  cuerpo: string;
}

/** Un marcador `{{CLAVE}}` del vocabulario cerrado, con su explicación. */
export interface MarcadorDeCotizacion {
  clave: string;
  ayuda: string;
}

export const ROTULO_APARTADO: Record<ApartadoDeCotizacion, string> = {
  metodologia: "Metodología",
  documentacion: "Documentación",
};

/**
 * El catálogo completo.
 *
 * FUERA del gate de maestros: elegir qué ítems entran en una cotización es
 * parte de cotizar, no de administrar la plataforma.
 */
export async function listarCotizacionItemsRequest(): Promise<CotizacionItem[]> {
  const respuesta = await apiFetch<{ data: CotizacionItem[] }>("/api/cotizacion-items");
  return respuesta.data;
}

/** Los párrafos fijos. Solo para quien administra maestros. */
export async function listarCotizacionTextosRequest(): Promise<CotizacionTexto[]> {
  const respuesta = await apiFetch<{ data: CotizacionTexto[] }>("/api/cotizacion-textos");
  return respuesta.data;
}

/** Los marcadores disponibles, para mostrarlos en el mantenedor. */
export async function listarMarcadoresRequest(): Promise<MarcadorDeCotizacion[]> {
  const respuesta = await apiFetch<{ data: MarcadorDeCotizacion[] }>(
    "/api/cotizacion-textos/marcadores",
  );
  return respuesta.data;
}

/**
 * Cambia la redacción de un párrafo.
 *
 * `codigo` y `apartado` no viajan porque no se editan: el primero es con lo
 * que la plantilla pide el texto y el segundo dónde se imprime.
 */
export async function guardarCotizacionTextoRequest(
  id: number,
  input: { nombre: string; cuerpo: string },
): Promise<CotizacionTexto> {
  const respuesta = await apiFetch<{ data: CotizacionTexto }>(`/api/cotizacion-textos/${id}`, {
    method: "PUT",
    body: JSON.stringify(input),
  });
  return respuesta.data;
}

/** Cambia el rótulo, el cuerpo o la posición de un ítem del catálogo. */
export async function guardarCotizacionItemRequest(
  id: number,
  input: { rotulo: string | null; cuerpo: string; orden: number },
): Promise<CotizacionItem> {
  const respuesta = await apiFetch<{ data: CotizacionItem }>(`/api/cotizacion-items/${id}`, {
    method: "PUT",
    body: JSON.stringify(input),
  });
  return respuesta.data;
}
